import React from 'react'
import { getUrl } from './Permalinks'
import AnimationWrapper from './Animations'
import FeedItem from '../components/general/FeedItem'

export const sort = (arr, options) => {
    return arr?.sort((a, b) => {
        if (options && options.data.order.direction === 'desc') {
            if (options.data.order.by === 'title') {
                return a.title < b.title ? 1 : -1
            } else {
                return new Date(a.date_published) > new Date(b.date_published)
                    ? 1
                    : -1
            }
        } else {
            if (options && options.data.order.by === 'title') {
                return a.title > b.title ? 1 : -1
            } else {
                return new Date(a.date_published) < new Date(b.date_published)
                    ? 1
                    : -1
            }
        }
    })
}

export const getInitialFeed = (options, data) => {
    if (options?.data?.collection === 'collectionSaleProfiles') {
        const feed = data?.collection
            .filter((item) =>
                options.data.categories.some((el) =>
                    item.node.categories.includes(el)
                )
            )
            .map(({ node }) => node)
        const sortedFeed = sort(feed, options)?.slice(0, options.data.limit)
        return { collection: 'collectionSaleProfiles', docs: sortedFeed }
    } else if (options?.data?.collection === 'posts') {
        const feed = data?.post
            .filter((item) =>
                options.data.categories.some((el) =>
                    item.node.categories.includes(el)
                )
            )
            .map(({ node }) => node)
        const sortedFeed = sort(feed, options)?.slice(0, options.data.limit)
        return { collection: 'post', docs: sortedFeed }
    } else if (options?.data?.collection === 'curated') {
        const fullFeed = []
        if (data?.post.length) {
            fullFeed.push(...data?.post)
        }
        if (data?.collection.length) {
            fullFeed.push(...data?.collection)
        }
        if (data?.page.length) {
            fullFeed.push(...data?.page)
        }
        const feed = fullFeed
            .filter((item) =>
                options.data.categories.some((el) =>
                    item.node.slug.includes(el)
                )
            )
            .map(({ node }) => node)
        const sortedFeed = sort(feed, options)?.slice(0, options.data.limit)
        return { collection: 'curated', docs: sortedFeed }
    }
}

export const prepareFeed = (data, options, pageData) => {
    const items = []
    let itemCounter = 0
    data?.docs?.forEach((item) => {
        const { collection } = data
        let caption = ''
        switch (collection) {
            case 'collectionWebProfiles':
            case 'collectioSaleProfiles':
            case 'collectionSearch':
                caption = item.content.excerpt
                break
            case 'pages':
                break
            default:
                // Assume 'posts'.
                break
        }

        if (
            (!options.hideCurrent ||
                (options.hideCurrent && item.slug !== pageData?.slug)) &&
            (!options.current ||
                (options.current && item.slug !== options.current)) // Old line, needs removing
        ) {
            items.push(
                <AnimationWrapper
                    key={itemCounter + item.slug}
                    type='fade-up'
                    delay={(itemCounter % 3) * 0.1}
                >
                    <FeedItem
                        options={{
                            alt: item.alt
                                ? `Learn more about the ${item.alt}`
                                : 'Learn more',
                            media: item.media,
                            imageData:
                                item.media.set?.length && item.media.set[0],
                            href:
                                getUrl(
                                    collection,
                                    item.slug,
                                    item.categories
                                ) || '#',
                            headline: item.title,
                            caption,
                            showTitle: options.showTitle,
                            showCaption: options.showCaption,
                            categories: item.categories,
                            overlay:
                                item.categories.includes('films') ||
                                item.categories.includes('publications')
                                    ? false
                                    : true,
                            saleProfileStatus: item.saleProfileStatus || [],
                            content: item.content,
                        }}
                    ></FeedItem>
                </AnimationWrapper>
            )
        }
        itemCounter++
    })
    return items
}
